import { Component, OnInit, ChangeDetectorRef, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { MapsSidebarService } from '../../maps-sidebar.service';

@Component({
  selector: 'app-hidden-filter',
  templateUrl: './hidden-filter.component.html',
  styleUrls: ['./hidden-filter.component.less']
})
export class HiddenFilterComponent implements OnInit {

  showHiddenProperty: boolean = true;
  showHiddenMarker: boolean = true;
  showHiddenRetailer: boolean = true;
  showHiddenAvailableSpace: boolean = true;
  hiddenItems: any[] = [];
  closeOnClickRef: any;
  updateHiddenItemsSubscription: any;
  hiddenFilterActiveSubscription: Subscription;


  constructor(public mapsSidebarService: MapsSidebarService, public ref: ChangeDetectorRef, public elementRef: ElementRef) { }

  ngOnInit() {
    this.closeOnClickRef = this.closeOnOutsideClick.bind(this);
    this.hiddenFilterActiveSubscription = this.mapsSidebarService.hiddenFilterActiveStream.subscribe((value)=> {
      if(value) {
        document.addEventListener('click', this.closeOnClickRef, true);
      }
    });
  }

  ngAfterViewInit() {
    (<any>window).Events.subscribe('updateHiddenItems',()=>{
      this.hiddenItems = (<any>window).hiddenItem.markers;
      this.mapsSidebarService.showHiddenFilter = this.mapsSidebarService.showHiddenFilter && this.hiddenItems.length > 0;
      (<any>window).hiddenItem.layerActive = this.mapsSidebarService.showHiddenFilter;
      (<any>window).Events.publish('detectChanges');
    });
  }

  closeOnOutsideClick(event: Event) {
    if (event.target !== this.elementRef.nativeElement
        && !this.elementRef.nativeElement.contains(event.target)
        && !(<any>window).hasClass(event.target, 'layer-filter-sub-header')
        && !(<any>window).hasClass(event.target, 'toggle-layers-holder')
        && !(<any>window).hasClass(event.target, 'filter-counter')
        && !(<any>window).hasClass(event.target, 'filter-icon')
        && !(<any>window).hasClass(event.target, 'property-svg')
        && !(<any>window).hasClass(event.target, 'arrow-icon')) {
        this.closeHiddenItemsFilter();
        document.removeEventListener('click', this.closeOnClickRef, true);
    }
  }

  closeHiddenItemsFilter() {
    this.mapsSidebarService.showHiddenFilter = false;
    (<any>window).hiddenItem.hideAll();
    (<any>window).Events.publish('detectChanges');
    (<any>window).localStorageHandler.updateSideBarToLS();
  }

  isHiddenOn() {
    return true;
  }

  toggleProperty(event) {
    if(!this.showHiddenProperty) {
      document.getElementById('change').className = 'material-icons ';
      this.showHiddenProperty = true;
    } else {
      document.getElementById('change').className = 'material-icons rotate';
      this.showHiddenProperty = false;
    }
      (<any>window).Events.publish('detectChanges');

  }

  toggleRetailer(event) {
    if(!this.showHiddenRetailer) {
      document.getElementById('change1').className = 'material-icons';
      this.showHiddenRetailer = true;
    } else {
      document.getElementById('change1').className = 'material-icons rotate';
      this.showHiddenRetailer = false;
    }
    (<any>window).Events.publish('detectChanges');
  }

  toggleMarker(event) {
    if(!this.showHiddenMarker) {
      document.getElementById('change2').className = 'material-icons';
      this.showHiddenMarker = true;
    } else {
      document.getElementById('change2').className = 'material-icons rotate';
      this.showHiddenMarker = false;
    }
    (<any>window).Events.publish('detectChanges');
  }

  toggleAvailableSpace(event) {
    if(!this.showHiddenAvailableSpace) {
      document.getElementById('change3').className = 'material-icons';
      this.showHiddenAvailableSpace = true;
    } else {
      document.getElementById('change3').className = 'material-icons rotate';
      this.showHiddenAvailableSpace = false;
    }
    (<any>window).Events.publish('detectChanges');
  }

  goToLocation(item) {
    let w = (<any>window);
    switch(item.type) {
      case 'pin':
        w.map.setCenter(item.getPosition());
        break;
      case 'retailer':
        w.map.setCenter(item.getOriginalPosition());
        break;
      case 'property-available-space':
        w.map.setCenter(item.getOriginalPosition());
        break;
      case 'property':
        w.map.setCenter(item.getOriginalPosition());
        break;
    }
  }

  resetHiddenItems() {
    this.mapsSidebarService.showHiddenFilter = false;
    (<any>window).hiddenItem.unhideAll();
  }

  removeSubscriptions() {
    this.updateHiddenItemsSubscription && this.updateHiddenItemsSubscription.unsubscribe();
    this.hiddenFilterActiveSubscription && this.hiddenFilterActiveSubscription.unsubscribe();
  }

  ngOnDestroy() {
    this.removeSubscriptions();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/maps-sidebar/components/hidden-filter/hidden-filter.component.ts